<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <div style="display: flex;">
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form" style="margin-left: -14px;margin-right: -6px;margin-bottom: 15px; flex: 1;">
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("user_id")}}
                </div>
              </div>
              <!-- 订单状态 {0:查询全部, 1:已支付, 2:支付失败, 3:已撤销, 4:未支付} -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box">
                  <el-input v-model="searchForm.user_id" :placeholder="$I18n('user_reg_acc_02')"/>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("email_or_phone")}}
                </div>
              </div>
              <!-- 订单状态 {0:查询全部, 1:已支付, 2:支付失败, 3:已撤销, 4:未支付} -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box">
                  <el-input v-model="searchForm.link_id" :placeholder="$I18n('email_or_phone_03')"/>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("last_fail_time")}}
                </div>
              </div>
              <!-- 表单-日期范围选择-创建时间 -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box" style="width: 330px;">
                  <el-date-picker :picker-options="pickerOptions" v-model="searchForm.date" class="md-date-form-item" align="left" type="datetimerange" range-separator="~" prefixIcon="no" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
                </div>
              </div>

              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("submis_time")}}
                </div>
              </div>
              <!-- 表单-日期范围选择-创建时间 -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box" style="width: 330px;">
                  <el-date-picker :picker-options="pickerOptions" v-model="searchForm.fault" class="md-date-form-item" align="left" type="datetimerange" range-separator="~" prefixIcon="no" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
                </div>
              </div>
            </div>
            <div style="display: flex;align-items: center;padding-bottom: 6px;">
              <!-- 按钮 {大屏幕模式} -->
              <div class="md-layout md-layout-item left-layout-item" :style="{'justify-content': 'flex-end','height':'36px'}">
                  <button class="left-icon md-info" @click="form_changeSearchData" style="margin-bottom: 0;">
                    <md-icon>search</md-icon>
                    {{$I18n("search")}}
                  </button>
                  <button class="left-icon md-info" @click="reset_serach" style="margin-bottom: 0;">
                    <md-icon>refresh</md-icon>
                    {{$I18n("reset")}}
                  </button>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 分页 -->
    <div class="md-layout-item md-size-100" style="padding-top: 0;">
      <md-card style="margin: 0;">
        <div style="padding: 20px 20px 0;">
          <scroll-table height="calc(100vh - 420px)">
            <md-table class="diy-gray" v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
                <md-table-cell :md-label="$I18n('user_id')">
                  {{item.user_id}}
                </md-table-cell>
                <md-table-cell :md-label="$I18n('email_or_phone')">
                  <template v-if="item.email">
                    {{item.email}}
                  </template>
                  <template v-else-if="item.phone">
                    {{item.phone}}
                  </template>
                  <template v-else></template>
                </md-table-cell>

                <md-table-cell :md-label="$I18n('feed_cont')">
                  <el-tooltip effect="dark" placement="bottom">
                    <div>{{item.sm_content}}</div>
                    <div slot="content" style="max-width: 40vw;">
                      {{item.show_detail.content}}
                    </div>
                  </el-tooltip>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('img')">
                  <div class="table-image-box">
                    <img class="table-image" v-for="(item,index) in item.show_detail.attach_list" 
                      :key="index"
                      :src="item"
                      :alt="index"
                      @click="() => bigImage(item)"
                    />
                  </div>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('last_fail_time')">
                  {{item.fault_time}}
                </md-table-cell>
                <md-table-cell :md-label="$I18n('submis_time')">
                  {{item.update_time}}
                </md-table-cell>
                <md-table-cell :md-label="$I18n('operate')" class="button-cell table-operate">
                  <a v-if="item.show_detail.log_url" :href="item.show_detail.log_url" download>
                    <md-button class="md-simple md-info md-table-md-button">
                      {{$I18n("log_download")}}
                    </md-button>
                  </a>
                  <md-button v-else @click.stop class="md-simple md-disabled md-table-md-button" style="cursor: not-allowed;">
                    {{$I18n("log_download")}}
                  </md-button>
                </md-table-cell>
                <!-- 操作 -->
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
          </scroll-table>
        </div>
        <table-page-v2 :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
      </md-card>
    </div>
    <black-shadow-modal ref="image" :image="showImageSrc"/>
  </div>
</template>
<script>
import {Tooltip as ElTooltip} from 'element-ui';
import BlackShadowModal from '@/components/Common/BlackShadowModal.vue';
import { timestampToString, nDaysAgo,/* nMonthsAgo, FormClass */ } from "@/common/tools.js";
export default {
  components: {
    ElTooltip,
    BlackShadowModal,
  },
  data() {
    const todayStart = nDaysAgo(0) + " 00:00:00";
    const todayEnd = nDaysAgo(0) + " 23:59:59";
    return {
      todayStart,
      todayEnd,
      showImageSrc: "",
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > new Date(todayEnd);
        },
      },
      searchForm : { // 查询表单用的数据
        user_id : "",
        link_id : "",
        date    : [todayStart,todayEnd],
        fault   : [todayStart,todayEnd],
      },
      searchData: {
        user_id: "",
        link_id: "",
        gmt_start: this.strTotime(todayStart),
        gmt_end  : this.strTotime(todayEnd),
        gmt_fault_start: this.strTotime(todayStart),
        gmt_fault_end  : this.strTotime(todayEnd),
      }, // 检索范围

      tableInitData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      total    : 0,
      currentPage : 1,

      canReload: true, // 防止重复查询
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    pageSize(){
      this.api_getPageData(1);
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    bigImage(item){
      this.showImageSrc = item;
      this.$refs.image.open();
    },
    reset_serach(){
      this.searchForm = { // 查询表单用的数据
        user_id : "",
        link_id : "",
        date    : [this.todayStart,this.todayEnd],
        fault   : [this.todayStart,this.todayEnd],
      }
    },
    strTotime(str){
      if(!str){
        return 0
      }
      return new Date(str).getTime() / 1000
    },
    form_changeSearchData(){
      this.searchData = {
        user_id: this.searchForm.user_id,
        link_id: this.searchForm.link_id,
        gmt_start: this.searchForm.date ?this.strTotime(this.searchForm.date[0]) :0,
        gmt_end  : this.searchForm.date ?this.strTotime(this.searchForm.date[1].replace("00:00:00", "23:59:59")) :0,
        gmt_fault_start: this.searchForm.fault ?this.strTotime(this.searchForm.fault[0]) :0,
        gmt_fault_end  : this.searchForm.fault ?this.strTotime(this.searchForm.fault[1].replace("00:00:00", "23:59:59")) :0,
      }
      this.api_getPageData(1);
    },
    // 获取页面信息
    api_getPageData(newPage){
      // 防止重复查询
      if(!this.canReload){
        return
      }
      this.canReload = false;
      if(newPage){
        this.currentPage = newPage
      }

      // 获取角色
      this.$api.getFeedList({ // api: /v2/user/admin/feedback/list
          ...this.searchData,
          type     : 2,
          state    : 0,
          detail_type: 1,
          page_size: this.pageSize,
          page_no  : newPage ?newPage :this.currentPage,
      })
        .then(this.$Then(res => {
          this.canReload = true;
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.canReload = true;
          this.tableInitData = [];
          this.total = 0;
        }))
    },
  },
  computed: {
    tableData(){ // 表格数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          var showDetail = {
            content: "",
            attach_list: [],
            log_url: "",
          };
          if(item.details && item.details.length > 0){
            var newDetail = item.details[item.details.length -1];
            showDetail = {
              ...showDetail,
              ...newDetail,
            }
            if(newDetail.attach){
              try{
                showDetail.attach_list = JSON.parse(newDetail.attach)
              }catch{
                console.error("Error attach :", newDetail.attach);
              }
            }
          }
          var sm_content = ""
          if(showDetail.content && showDetail.content.length > 20){
            sm_content = showDetail.content.slice(0,20) + "..."
          } else {
            sm_content = showDetail.content
          }
          return {
            ...item,
            sm_content: sm_content,
            fault_time: timestampToString(item.gmt_fault * 1000),
            update_time: timestampToString(item.gmt_create * 1000),
            show_detail: showDetail,
          }
        });
      }
    },
  },
}
</script>
<style lang="css" scoped>
button.left-icon /deep/ i{
  color: #FFFFFF !important;
}
button.left-icon{
  background: #00bcd4;
  border: none;
  color: #FFFFFF;
  border-radius: 4px;
  line-height: 36px;
  height: 36px;
  padding: 0 30px;
  cursor: pointer;
}
/*.left-icon /deep/ .md-ripple{
  padding: 4px 30px !important;
}*/
.table-image-box{
  margin: 0 -5px;
}
.table-image{
  max-height: 34px;
  width: auto;
  max-width: 34px;
  margin: 0 5px;
}
.table-operate{
  width: 80px;
}
.table-ceil{
  display: inline-block;
  line-height: 36px;
  max-width: 15vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .md-card .md-subhead{
  opacity: 1 !important;
}
.order-card-title-span{
  color: #A5A5A5;
  padding-right: 24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
}
.order-info-body{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.order-info-body .md-layout-item>div{
  margin-bottom: 8px;
}
/deep/ .md-card-actions.md-alignment-right{
  border-top: 0 !important;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info{
  margin-bottom: 0px;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info .md-ripple{
  padding: 12px 16px;
}
/deep/ .md-card-actions.md-alignment-right{
  padding-top: 0 !important;
}
.md-table-md-button{
  height: 37px;
}
.table-search-form-box /deep/ .md-date-form-item{
  padding-right: 0 !important;
}
.table-search-form-box /deep/ .el-date-editor .el-range-input{
  width: 44%;
}
.table-search-form-box.none-clean /deep/ .el-date-editor .el-range-input{
  width: 47%;
}
.table-search-form-box.none-clean{
  padding-right: 8px;
}
.table-search-form-box.none-clean /deep/ .el-input__icon.el-range__close-icon{
  display: none;
}
</style>
<style lang="scss" scoped>
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px;
    text-align: left;
  }
  .md-chip{
    cursor:pointer;
    line-height: 24px;
    height: 24px;
    margin: 2px 3px !important;
  }
  .md-chip .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip:hover .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip.md-info{
    background: rgb(0, 188, 212) !important;
  }
  .md-chip.md-danger{
    background: #f44336 !important;
  }
  .md-info{
    margin-top : 0 !important;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    font-weight: 700;
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    font-size: 14px;
    font-weight: 400;
    font-family: Microsoft YaHei;
    color: #A5A5A5;
  }
  .order-card .foot-box .foot-box-right div{
    margin-right : 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  .left-btn {
    text-align:left;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  @media screen and ( max-width: 600px ){
    .md-card .md-subhead {
      margin-left: 0;
    }
    .order-card-title span{
      display:block;
    }
    .foot-box span, .foot-box div{
      width: 50%;
      margin-right: -16px !important;
      margin-left: 16px !important;
    }
    .order-card{
      padding: 16px 0;
    }
  }
</style>
